import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import AuthLandingLayout from '../components/AuthLandingLayout';
import { ensureCustomerSelection } from '../lib/selectedCustomer';

const LoginPage = ({ onLogin }) => {
  useEffect(() => {
    ensureCustomerSelection({ redirectIfMissing: true });
    onLogin();
  }, [onLogin]);

  return (
    <AuthLandingLayout tagline="Sender deg til Entra ID …">
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress color="secondary" />
      </Box>
    </AuthLandingLayout>
  );
};

export default LoginPage;
